<template>
  <v-card
    color="grey darken-3"
    dark
  >
    <v-card-text>
      <avatar />
      <div class="text-sm-center mb-4 mt-3">
        <h1>
          Christophe <span class="light-blue--text text--lighten-3">Hubert</span>
        </h1>
        <span>
          There is no place like 127.0.0.1
        </span>
      </div>

      <sidebar-section :options="sections.info" />
      <sidebar-section :options="sections.socials" />
      <sidebar-section :options="sections.hobbies">
        <template v-slot:item="{item}">
          <v-chip>
            <v-avatar>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-avatar>
            {{ item.text }}
          </v-chip>
        </template>
      </sidebar-section>
      <sidebar-section :options="sections.languages">
        <template v-slot:items="{items}">
          <v-container pa-0>
            <v-layout
              wrap
              class="text-xs-center"
            >
              <template
                v-for="(item, i) in items"
              >
                <v-flex
                  :key="i"
                  md3
                  sm4
                  xs6
                >
                  <v-progress-circular
                    rotate="360"
                    size="65"
                    width="2"
                    :value="item.value"
                    color="white"
                    class="ma-2"
                  >
                    {{ item.text }}
                  </v-progress-circular>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </template>
      </sidebar-section>
    </v-card-text>
  </v-card>
</template>

<script>
import Avatar from '@/views/dark-template/sidebar/Avatar'
import SidebarSection from '@/views/dark-template/sidebar/Section'
export default {
  name      : 'Sidebar',
  components: { SidebarSection, Avatar },
  data () {
    return {
      sections: {
        info: {
          title: 'INFO',
          items: [
            {
              name: 'Email',
              icon: 'mdi-email',
              text: 'hubert.christophe@gmail.com',
            },
            {
              name: 'Website',
              icon: 'mdi-web',
              text: 'hubertchristophe.com',
              link: 'https://www.hubertchristophe.com',
            },
            {
              name: 'Birth Year',
              icon: 'mdi-cake-variant',
              text: '1983',
            },
            {
              name: 'Living in',
              icon: 'mdi-map-marker',
              text: 'Jakarta, Indonesia',
            },
          ],
        },
        socials: {
          title: 'SOCIALS',
          items: [
            {
              icon: 'mdi-github-circle',
              text: 'github.com/chrishubert',
              link: 'https://github.com/chrishubert',
            },
            {
              icon: 'mdi-linkedin-box',
              text: 'linkedin.com/in/hubertchristophe/',
              link: 'https://www.linkedin.com/in/hubertchristophe/',
            },
            {
              icon: 'mdi-stack-overflow',
              text: 'stackoverflow.com/users/4258328/christophe-hubert',
              link: 'https://stackoverflow.com/users/4258328/christophe-hubert',
            },
          ],
        },
        hobbies: {
          title: 'HOBBIES',
          items: [
            {
              icon: 'mdi-podium-gold',
              text: 'Wall Climbing',
            },
            {
              icon: 'mdi-lifebuoy',
              text: 'Kite Surfing',
            },
            {
              icon: 'mdi-auto-fix',
              text: 'Hacking',
            },
            {
              icon: 'mdi-teach',
              text: 'Teaching',
            },
            {
              icon: 'mdi-bug-check',
              text: 'Destroying bugs',
            },
            {
              icon: 'mdi-bitcoin',
              text: 'Crypto Trading',
            },
          ],
        },
        languages: {
          title: 'LANGUAGES',
          items: [
            {
              text : 'English',
              value: 95,
            },
            {
              text : 'French',
              value: 100,
            },
            {
              text : 'Bahasa',
              value: 70,
            },
          ],
        },
      },
    }
  },
}
</script>

<style scoped>
.sidebar{
    background: #2e2e2e;
}
</style>
